import React, { useContext } from "react";
import {
  Button,
  HelpDrawerToggle,
  HelpDrawer,
  CloseIconThin,
} from "@cmsgov/ds-medicare-gov";
import { Routes } from "../../app";
import { SearchResultsState } from "./useSearchResultsHelper";
import { useTranslate } from "../../helpers";
import { AppContext } from "../../app/store";
import { useHistory, useLocation } from "react-router";
import {
  AnalyticsActionType,
  AnalyticsButtonStyle,
  AnalyticsButtonType,
} from "../../app/contexts/Analytics/types";

interface OMHDProps {
  pageState: SearchResultsState;
  updatePageState: (x: Partial<SearchResultsState>) => void;
}

const OriginalMedicareHelpDrawer: React.FC<OMHDProps> = ({
  pageState,
  updatePageState,
}) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const { search } = useLocation();
  const history = useHistory();

  return (
    <div className="mct-u-width--full">
      <HelpDrawerToggle
        helpDrawerOpen={pageState.showOriginalMedicareDrawer}
        showDrawer={(): void =>
          updatePageState({ showOriginalMedicareDrawer: true })
        }
      >
        {t("search_results_page.see_original_medicare_coverage")}
      </HelpDrawerToggle>
      {pageState.showOriginalMedicareDrawer && (
        <div className="mct-c-help-drawer">
          <HelpDrawer
            heading={t("search_results_page.see_original_medicare_coverage")}
            onCloseClick={(): void =>
              updatePageState({ showOriginalMedicareDrawer: false })
            }
            closeButtonText={<CloseIconThin />}
          >
            <p>
              <b>{t("search_results_page.original_medicare_includes")}</b>{" "}
              {t("search_results_page.original_medicare_includes_hospital")}
            </p>

            <ul>
              <li>
                {t("search_results_page.original_medicare_drug_coverage")}
              </li>
              <li>{t("search_results_page.original_medicare_medigap")}</li>
            </ul>

            <Button
              variation="solid"
              className="ds-u-margin-top--7"
              onClick={(): void => {
                dispatch({
                  type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
                  settings: {
                    button: {
                      buttonStyle: AnalyticsButtonStyle.PRIMARY,
                      buttonType: AnalyticsButtonType.BUTTON,
                      text: t("search_results_page.see_original_medicare"),
                    },
                  },
                });
                updatePageState({
                  includeOriginalMedicare: true,
                  showOriginalMedicareDrawer: false,
                });
              }}
            >
              {t("search_results_page.see_original_medicare")}
            </Button>
          </HelpDrawer>
        </div>
      )}
      <Button
        variation="ghost"
        className="ds-u-padding--0"
        onClick={(): void => {
          const nextRoute = `${Routes.sanctionedPlans}${search}`;
          dispatch({
            type: AnalyticsActionType.SEND_BUTTON_ENGAGEMENT_EVENT,
            settings: {
              button: {
                buttonStyle: AnalyticsButtonStyle.TRANSPARENT,
                buttonType: AnalyticsButtonType.BUTTON,
                text: t("sanctioned_plans_page.view_sanctioned_plans"),
              },
              linkUrl: nextRoute,
            },
          });
          history.push(nextRoute);
        }}
      >
        {t("sanctioned_plans_page.view_sanctioned_plans")}
      </Button>
    </div>
  );
};

export default OriginalMedicareHelpDrawer;
